<template>
    <div class="contain" id="jumpteam">
        <div class="boss">
            <div class="first">
                <div class="bosstip" :class="{bosstipEn: isEn()}">
                    <div class="title">刘祎玮</div>
                    <div class="des">{{getLan('43061ed0-caa2-4dfb-b86d-7af5ed6c09dc')}}</div>
                    <div class="say">{{getLan('e7b9ad03-40b0-4ee9-a725-545594bd0d17')}}</div>
                    <img
                        src="@/assets/team/boss1.jpg"
                        style="object-fit:cover;border-radius:50%;width:5rem;height: 4.93rem;"
                    />
                </div>
            </div>
            <div class="second">
                <div class="bosstip" :class="{bosstipEn: isEn()}">
                    <div class="title">黎 钟</div>
                    <div class="des">{{getLan('7f75ef68-1536-413d-b070-148ad0d120e1')}}</div>
                    <div class="say">{{getLan('4c75d5ec-824a-4c34-b5c7-91edf2ae434b')}}</div>
                    <img src="@/assets/team/boss2.jpg" />
                </div>
            </div>
        </div>
        <div class="info">
            <div class="top">
                <div>
                    <div
                        class="picandword"
                        @mouseenter="changeHover(0, true)"
                        @mouseleave="changeHover(0, false)"
                    >
                        <div class="imgdec">{{getLan('9e5c350c-ae61-46ba-9c63-cee46ff0ddf1')}}</div>
                        <transition name="bounce">
                            <div v-show="hover[0]" class="morehover">
                            <span>{{getLan('3fdae005-4596-4595-a82c-ce1c0ed8dc9d')}}</span></div>
                        </transition>
                        <img src="@/assets/team/team13.jpg" class="type1" />
                    </div>
                    <div
                        class="picandword"
                        @mouseenter="changeHover(1, true)"
                        @mouseleave="changeHover(1, false)"
                    >
                        <div class="imgdec">{{getLan('145c3e7a-38c4-4b0e-9262-5f516f0f02fd')}}</div>
                        <transition name="bounce">
                            <div v-show="hover[1]" class="morehover">
                            <span>{{getLan('4067067c-98df-4ee0-9356-c85e605345d5')}}</span></div>
                        </transition>
                        <img src="@/assets/team/team14.jpg" class="type2" />
                    </div>
                    <div
                        class="picandword"
                        @mouseenter="changeHover(2, true)"
                        @mouseleave="changeHover(2, false)"
                    >
                        <div class="imgdec">{{getLan('0a6cf8e7-bcba-4f84-9077-5652b7764763')}}</div>
                        <transition name="bounce">
                            <div v-show="hover[2]" class="morehover">
                            <span>{{getLan('d359cf9b-4426-45c4-b7a3-8ba1d6337212')}}</span></div>
                        </transition>
                        <img src="@/assets/team/team11.jpg" class="type22" />
                    </div>
                </div>
                <div>
                    <div
                        class="picandword"
                        @mouseenter="changeHover(3, true)"
                        @mouseleave="changeHover(3, false)"
                    >
                        <div class="imgdec">{{getLan('41b508d9-eb43-4d7a-8bfe-3e0187992a70')}}</div>
                        <transition name="bounce">
                            <div v-show="hover[3]" class="morehover">
                            <span>{{getLan('d326b03a-d628-4d52-819f-ed4991340045')}}</span></div>
                        </transition>
                        <img src="@/assets/team/team12.jpg" class="type3" />
                    </div>
                </div>
                <div>
                    <div
                        class="picandword"
                        @mouseenter="changeHover(4, true)"
                        @mouseleave="changeHover(4, false)"
                    >
                        <div class="imgdec">{{getLan('69a57e11-9ea4-42da-a5b7-a519c97f96d9')}}</div>
                        <transition name="bounce">
                            <div v-show="hover[4]" class="morehover">
                            <span>{{getLan('198b77d3-8865-40a8-b465-6c63e50ea82e')}}</span></div>
                        </transition>
                        <img src="@/assets/team/team10.jpg" class="type4" />
                    </div>
                    <div
                        class="picandword"
                        @mouseenter="changeHover(5, true)"
                        @mouseleave="changeHover(5, false)"
                    >
                        <div class="imgdec">{{getLan('199cc35b-8a37-4ced-8fae-43ecf2a73e5b')}}</div>
                        <transition name="bounce">
                            <div v-show="hover[5]" class="morehover">
                            <span>感谢陪伴，感谢给予，感谢参与。我们像是一只优秀球队，始终高效协作，携手并进。</span></div>
                        </transition>
                        <img src="@/assets/team/team9.jpg" class="type4" />
                    </div>
                </div>
            </div>
        </div>
        <img class="bottombanner" src="@/assets/team/bottombanner.jpg" />
        <div class="overtip">
            <div class="wd">{{getLan('4bb3c11d-0c99-4cb7-bb8f-3b8558dfd5ef')}}</div>
            <div class="add" @click="addUs">{{getLan('aef8a172-989c-4a3e-87b9-2cc72ffcb690')}}</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            hover: [false, false, false, false, false, false, false]
        }
    },
    methods: {
        changeHover(i, result) {
            this.$set(this.hover, i, result)
        },
        canShow(i) {
            return this.hover[i]
        },
        addUs() {
            document.querySelector('#addus').click()
        }
    }
}
</script>

<style scoped>
.contain {
    background: linear-gradient(#f7f9fb, #ffffff);
    position: relative;
    width: 100rem;
    box-sizing: border-box;
}
.boss {
    display: flex;
    height: 27.23rem;
    justify-content: center;
    align-items: center;
}
@media (min-width: 1156px) {
    .awards {
        width: 60rem;
        max-height: 30rem;
    }
}
@media (max-width: 1156px) {
    .awards {
        width: 80rem;
        max-height: 50rem;
    }
}
.first,
.second {
    width: 40rem;
    height: 15rem;
    display: flex;
    justify-content: center;
}
.boss .bosstip {
    width: 28rem;
    height: 13rem;
    box-shadow: 0rem 1rem 3rem 0rem rgba(65, 66, 81, 0.11);
    background: #fff;
    padding: 0.83rem 0.89rem 3.09rem 3.2rem;
    box-sizing: border-box;
    position: relative;
}
.boss .bosstip > img {
    position: absolute;
    left: -2.5rem;
    top: -2.5rem;
    width: 5rem;
    height: 4.93rem;
}
.bosstipEn {
    height: 16.1rem !important;
}
.bosstip .title {
    color: #333;
    font-size: 1.31rem;
    font-weight: bold;
    line-height: 2.51rem;
}

.bosstip .des {
    font-size: 0.73rem;
    font-weight: 500;
    color: #666;
    line-height: 1.28rem;
}

.bosstip .say {
    font-size: 0.73rem;
    font-weight: 500;
    color: #999;
    line-height: 1.17rem;
    margin-top: 1.5rem;
}

.info {
    margin-left: 10rem;
    font-size: 0;
    margin-bottom: 6.18rem;
    margin-top: 3rem;
}
.morehover {
    position: absolute;
    color: #fff;
    font-size: 1.1rem !important;
    z-index: 50;
    left: 0rem;
    bottom: 0rem;
    width: 100%;
    background: rgba(51, 51, 51, .8);
    height: 100%;
    box-sizing: border-box;
    padding-top: 4.71rem;
    padding-left: 1.15rem;
    padding-right: 1rem;

    border: 0.1rem solid red;
    border-left-color: transparent;
    border-top-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;
    background-clip: padding-box;
    border-left-width: 0.4rem;
    border-right-width: 0.4rem;
    border-top-width: 0.35rem;
    border-bottom-width: 0.35rem;
    -webkit-line-clamp: 4;

    overflow: hidden;
}

.bounce-enter-active {
    animation: moretip 1s;
}
.bounce-leave-active {
    animation: lesstip 2s;
}
@keyframes lesstip {
    0% {
        font-size: 0;
        height: 100%;
        padding-top: 4.71rem;
    }
    100% {
        font-size: 0;
        height: 0%;
        padding-top: 0;
    }
}
@keyframes moretip {
    0% {
        height: 0%;
        padding-top: 0;
        font-size: 0 !important;
    }
    100% {
        height: 100%;
        padding-top: 4.71rem;
        font-size: 0.94rem !important;
    }
}
.picandword {
    display: inline-block;
    position: relative;
    padding: 0.4rem 0.37rem;
}

.imgdec {
    color: #fff;
    position: absolute;
    z-index: 100;
    padding-top: 1.73rem;
    padding-left: 1.51rem;
    font-size: 1.3rem !important;
    line-height: 2.33rem;
    font-weight: 500;
    left: 0;
    top: 0;
}
.picandword img {
    object-fit: cover;
}
.info div {
    font-size: 0;
}
.info img {
    position: relative;
    object-fit: cover;
}
.type1 {
    width: 28rem;
    height: 22rem;
}
.type2 {
    width: 23rem;
    height: 22rem;
}
.type22 {
    width: 27rem;
    height: 22rem;
}
.type3 {
    width: 79.5rem;
    height: 28.86rem;
}
.type4 {
    width: 39.5rem;
    height: 28.86rem;
}

.bottombanner {
    width: 100rem;
    height: 17rem;
}

.overtip {
    position: absolute;
    bottom: 4.97rem;
    left: 50%;
    transform: translateX(-50%);
}
.overtip .wd {
    color: #fff;
    font-size: 2.62rem;
    line-height: 3.48rem;
    white-space: nowrap;
}

.overtip .add {
    color: #fff;
    background: #fd9a27;
    border-radius: 1.4rem;
    width: 10rem;
    height: 2.83rem;
    line-height: 2.83rem;
    text-align: center;
    font-size: 1.35rem;
    /* margin-left: 10.68rem; */
    margin: auto;
    margin-top: 2rem;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Team.vue